'use client'

import { AboutSkeleton } from './about-skeleton'

type Props = {
  about_us: string | ''
}

export function About({ about_us }: Props) {
  return (
    <div className='relative mt-6 mb-4 flex justify-between py-4 text-xl'>
      {about_us ? (
        <div dangerouslySetInnerHTML={{ __html: about_us }} />
      ) : (
        <AboutSkeleton />
      )}
    </div>
  )
}
